export default __webpack_public_path__ + "static/media/no-match.e6ade868.png";